import { render, staticRenderFns } from "./SmartformPanel.vue?vue&type=template&id=ef390fa8&scoped=true"
import script from "./SmartformPanel.vue?vue&type=script&lang=js"
export * from "./SmartformPanel.vue?vue&type=script&lang=js"
import style0 from "./SmartformPanel.vue?vue&type=style&index=0&id=ef390fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef390fa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VForm,VSwitch})
